import React, { useContext, useEffect, useState } from "react";
import Sidenavigation from "../layouts/Sidenavigation";
import Topnavigation from "../layouts/Topnavigation";
import Breadcrumb from "../sections/Orders/Breadcrumb";
import Ordertable from "../sections/Orders/Ordertable";
import Quickbar from "../layouts/Quickbar";
import AuthContext from "../../context/auth-context";
import OrderNewtable from "../sections/Ordersnew/Ordernewtable";

export const Orders = (props) => {
  const ctx = useContext(AuthContext);
  const authPermission = localStorage.getItem("PermissionDetails");
    const [orderHide, setHideOrder] = useState(true);
    const [mOrderHide, setHideMOrder] = useState(true);
  
    useEffect(() => {
      JSON.parse(authPermission).forEach(function (loca) {
  
        if (
          loca.access_level.access_level == "ADMIN"
        ) {
          setHideOrder(false);
        }

        if (
          loca.access_level.access_level == "STORE_ADMIN_USER"
        ) {
          setHideOrder(false);
        }

        if (
          loca.access_level.access_level == "SUPER_ADMIN"
        ) {
          setHideMOrder(false);
        }

        if (
          loca.access_level.access_level == "SALES_USER"
        ) {
          setHideMOrder(false);
        }

        if (
          loca.access_level.access_level == "STORE_USER"
        ) {
          setHideMOrder(false);
        }

      });
    }, [authPermission]);

  return (
    <>
      <div
        hidden={mOrderHide}
        className={
          ctx.darkMode
            ? "ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar ms-dark-theme"
            : "ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar"
        }
      >
        <Sidenavigation />
        <main className="body-content">
          <Topnavigation />
          <div className="ms-content-wrapper">
            <div className="row">
              <div className="col-md-12">
                <Breadcrumb />
                <Ordertable />
              </div>
            </div>
          </div>
        </main>
        <Quickbar />
      </div>
      <div
        hidden={orderHide}
        className={
          ctx.darkMode
            ? "ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar ms-dark-theme"
            : "ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar"
        }
      >
        <Sidenavigation />
        <main className="body-content">
          <Topnavigation />
          <div className="ms-content-wrapper">
            <div className="row">
              <div className="col-md-12">
                <Breadcrumb/>
                <OrderNewtable />
              </div>
            </div>
          </div>
        </main>
        <Quickbar />
      </div>
    </>
  );
};

export default Orders;
